import { useState, useEffect, useContext, Fragment, useRef } from "react";
// import ReCAPTCHA from 'react-google-recaptcha';

import classes from './PreReg.module.scss';
import Ajax from '../../../../../Handler/Ajax';
// import MaskedInput from 'react-text-mask';
import Validator from '../../../../../Handler/Validator';
import validator from 'validator';
import alert from '../../../../../assets/icons/alert-circle-red.svg';
// import InternationalPhone from '../../../../Form/InternationalPhone';
import GovSpinner from '../../../../Form/GovSpinner';
import Toast from "../../../../Form/Toast";
import arrowLeftWhite from '../../../../../assets/icons/arrow-left-white.svg';
import arrowPanel from '../../../../../assets/icons/arrow-head-circle-down.svg';
import man from '../../../../../assets/img/man.png';
import Modal from "../../../../General/Static/Modal/Modal";
import PreRegTwoContact from "./PreRegTwoContactPopup/PreRegTwoContact";
import PreRegOneContact from "./PreRegOneContactPopup/PreRegOneContact";
import LoginContext from '../../../../../store/login-context';
import Marketing from "../Marketing/Marketing";
import ReactInternationalPhone from "../../../../Form/ReactInternationalPhone/ReactInternationalPhone";
import MaskInput from "../../../../General/Static/MaskInput/MaskInput";
import DynamicText from "../../../../General/Static/DynamicText/DynamicText";

declare function Translate(key: string): string;
declare var _siteSettings: any;
declare var _curLang: any;
declare var _loginMethodSmsOtpUrl: any;

const PreRegistration = (props) => {
    let recaptchaRef:any = useRef(undefined);
    let mailRef= useRef<HTMLInputElement>(null);
    let marketingRef:any = useRef(undefined);
    const ctx = useContext(LoginContext);

    const [captcha, setCaptcha] = useState(true);
    const [captchaToken, setCaptchaToken] = useState(''); 
    const [userId,setUserId] = useState('');
    const [isUserIdValid,setIsUserIdValid] = useState(false);
    const [idBlur,setIdBlur] = useState(false);
    const [idDirty,setIdDirty] = useState(false);
    const [mail,setMail] = useState('');
    const [mailDirty,setMailDirty] = useState(false);
    const [isMailValid,setIsMailValid] = useState(false);
    const [typedNumber,setTypedNumber] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [mobileDirty,setMobileDirty] = useState(false);
    const [isPhoneValid,setIsPhoneValid] = useState(false);
    const [mobileValMsg,setMobileValMsg] = useState('');
    const [serverMessage,setServerMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [showTwoContactModal, setShowTwoContactModal] = useState(false);
    const [showOneContactModal, setShowOneContactModal] = useState(false);
    const [maskedEmail, setMaskedEmail] = useState('');
    const [maskedPhone, setMaskedPhone] = useState('');
    const [phoneAriaInvalid, setPhoneAriaInvalid] = useState(false);
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams && urlParams.has('src')){
            var source = urlParams.get('src')?.trim();
            if(source === "newuser"){
                ctx.displayRegForm(true); 
            }
        }
    },[]);

    useEffect(() => {
        document.title=Translate("N_General_SignUp_Title");
    },[_curLang]);

    useEffect(() => {
        if(userId.length > 0 && !idDirty){
          setIdDirty(true);      
        }  
    },[userId]);

    useEffect(() => {
        if(mail.length > 0 && !mailDirty){
          setMailDirty(true);
        }
      },[mail]);

      useEffect(() => {
        if(typedNumber.length > 0 && !mobileDirty){
          setMobileDirty(true);
        }
      },[typedNumber ]);

                     
    const handleUserId = (e) => {
        const regex = /^[0-9]{0,9}$/;
        const digitsOnly = e.target.value.toString().replace(/-/g,'');
        if (regex.test(digitsOnly)){
           setUserId(digitsOnly);   
        }

        if(idBlur){
            if(Validator.IdIsValide(digitsOnly) && (digitsOnly.length === 0 || digitsOnly.length === 9)){
                setIsUserIdValid(true);                 
                document?.getElementById("userId")?.removeAttribute("aria-invalid");
                document?.getElementById("userId")?.removeAttribute("aria-errormessage");
            }
            else{
                setIsUserIdValid(false);                
                document?.getElementById("userId")?.setAttribute("aria-invalid","true");
                document?.getElementById("userId")?.setAttribute("aria-errormessage","idErr");
            }
        }             
    };
    
    const handleEnter = (event) => {
    if (event.charCode === 13 || event.charCode === 32) {
        Submit();
    }
    };

    const isIdValid = () => {
        if (Validator.IdIsValide(userId) && idLengthValidation()){
            return true;
        }
        else{
            return false;
        }       
    };
    
    const idLengthValidation = () => {
        if(userId.length === 0 || userId.length === 9){
            return true;
        }
        else{           
            return false;
        }
    }

    const handleIDBlur = ()=>
    {
        setIdBlur(true); 
        if(isIdValid()){
            setIsUserIdValid(true);           
            document?.getElementById("userId")?.removeAttribute("aria-invalid");
            document?.getElementById("userId")?.removeAttribute("aria-errormessage");
        }
        else{
            setIsUserIdValid(false);            
            document?.getElementById("userId")?.setAttribute("aria-invalid","true");
            document?.getElementById("userId")?.setAttribute("aria-errormessage","idErr");
        }                                             
    };

    const handleIDFocus = ()=>
    {
        setIdBlur(false);
    }

    const handleMailValue = (e) => {        
        setMail(e.target.value); 
        setIsMailValid(validator.isEmail(e.target.value));
        if(!validator.isEmail(e.target.value)){
            mailRef.current?.setAttribute("aria-invalid","true");
            mailRef.current?.setAttribute("aria-errormessage","mailErr");
        }
        else{
            mailRef.current?.removeAttribute("aria-invalid");
            mailRef.current?.removeAttribute("aria-errormessage");
        }
    };

    // const handlePhoneValue = (isValid, value, countryData, number) => {
    //     value = value.replace(/[^\d\-]/g,'');     
    //     var errMsg = '';
    //     if (value.substring(0, 2) === "05" && number.substring(0,4) === "+972" && value.length === 10){
    //       isValid = true
    //     }
    //     if (isValid) {
    //       setIsPhoneValid(true);  
    //       setPhoneAriaInvalid(false);
    //     } else {
    //       setIsPhoneValid(false); 
    //       setPhoneAriaInvalid(true);  
    //       if(value.length === 0){
    //         errMsg = Translate('N_General_Error_FILL_ID_MOBILE_INPUT_TEXT');
    //       }
    //       else if(number.substring(0,4) === "+972" && value.length < 10){
    //         errMsg = Translate('N_General_Error_INVALID_MOBILE_Too_short');
    //       }
    //       else{
    //         errMsg = Translate('N_General_Error_INVALID_MOBILE_1');
    //       }            
    //     }

    //     let editedPhone = number.replace(/[\s-]/g, '');
    //     setPhoneNumber(editedPhone);
    //     setTypedNumber(value);
    //     setMobileValMsg(errMsg);    
    // };

    // const handleFlagChange = () => {
    // // setValue('');
    // setTypedNumber('');    
    // };

    const isAllInputsValid = () => {
        if(Validator.IdIsValide(userId) && isMailValid && isPhoneValid){
            return true;
        }
        else{
            return false;
        }
    };

    const backToLoginPage = () => {
        window.location = _loginMethodSmsOtpUrl;
    };

    const backToLoginPagePress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            backToLoginPage();  
        }
    }

    const forwardToForgotPassword = () => {
        window.location.href = `${_siteSettings.forgottenPasswordLink}&locale=${_curLang}`;
    };

    const forwardToForgotPassPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            forwardToForgotPassword();  
        }
    }

    // const executeCaptcha = () => {           
    //     recaptchaRef.current.execute();              
    // };

    // const callback = (token) => {    
    //     setCaptcha(false);
    //     setCaptchaToken(token);  
                     
    //     Ajax.PreRegCheck(userId, mail, phoneNumber, token)
    //         .then((data: any) => {
    //             setLoading(false);  
    //             setShowTwoContactModal(true);                    
    //         })
    //         .catch((data:any) => {
    //             setLoading(false);
    //             if(data.errorCode === "N_General_ERROR_PRE_REG_USER_PARTIALLY_FOUND"){
    //                 setMaskedEmail(data.maskedEmail);
    //                 setMaskedPhone(data.setMaskedPhone);
    //                 setShowOneContactModal(true);
    //             }
    //             else if (data.errorCode  === "N_General_ERROR_PRE_REG_USER_NOT_FOUND"){                   
    //                 props.setUserDetails(userId, mail, phoneNumber);
    //                 props.setCurrentScreenStep(ctx.preRegScreenCollection.introduction);                    
    //             }
    //             else{
    //                setServerMessage(Translate(data.errorCode ) !== '' ? Translate(data.errorCode ) : Translate('N_General_Error_SYSTEM_ERROR'));   
    //             }                                  
    //         });        
    // };

    // const onCaptchaExpired = () => {
    //     setCaptcha(true);
    //     setCaptchaToken('');    
    // };

    const Submit = () => {
        setServerMessage('');
        if(!isAllInputsValid()) return;

         //create custom event id for glassbox
        if(userId.length === 9){         
            const gbDetector = window['_detector']; 
            if(gbDetector){
                gbDetector.triggerCustomEvent('userIsraeliIdLogin', userId, [document.getElementById("userId")]);
            }
        }

        if(ctx.devMode){
            props.setUserDetails(userId, mail, phoneNumber);
            props.setCurrentScreenStep(ctx.preRegScreenCollection.introduction); 
        }
        else{
            setLoading(true);
            // executeCaptcha();     

            Ajax.PreRegCheck(userId, mail, phoneNumber)
            .then((data: any) => {
                setLoading(false);  
                setShowTwoContactModal(true);                    
            })
            .catch((data:any) => {
                setLoading(false);
                if(data.errorCode === "N_General_ERROR_PRE_REG_USER_PARTIALLY_FOUND"){
                    setMaskedEmail(data.maskedEmail);
                    setMaskedPhone(data.setMaskedPhone);
                    setShowOneContactModal(true);
                }
                else if (data.errorCode  === "N_General_ERROR_PRE_REG_USER_NOT_FOUND"){                   
                    props.setUserDetails(userId, mail, phoneNumber);
                    props.setCurrentScreenStep(ctx.preRegScreenCollection.introduction);                    
                }
                else{
                   setServerMessage(Translate(data.errorCode ) !== '' ? Translate(data.errorCode ) : Translate('N_General_Error_SYSTEM_ERROR'));   
                }                                  
            });        
        }                                  
    }
    
      const updatePhoneNumber = (phone:string, isValid:boolean, inputValue:string) => {
        var errMsg = '';

        setPhoneNumber(phone);
        setIsPhoneValid(isValid);
        setMobileDirty(true);

        if(!isValid){
            if(inputValue.length === 0){
              errMsg = Translate('N_General_Error_FILL_ID_MOBILE_INPUT_TEXT');
            }
            else if(phone.substring(0,3) === "+972" && inputValue.length < 10){
                errMsg = Translate('N_General_Error_INVALID_MOBILE_Too_short');
            }
            else{
                errMsg = Translate('N_General_Error_INVALID_MOBILE_1');
            } 
                  
            setMobileValMsg(errMsg); 
      
          }
    };

    const countryChangeHandler = (country:string) => {
        setMobileDirty(false);
        setIsPhoneValid(false);
    };


    const togglePanel = () => {
        marketingRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    };


    return (
        <Fragment>
            <GovSpinner show={loading} />

            {/* <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={_siteSettings.recaptchaSiteKey}
                onChange={callback}
                onExpired={onCaptchaExpired}
                size='invisible'
            /> */}

            {showTwoContactModal &&
                <Modal>
                    <PreRegTwoContact />
                </Modal>
            }

            {showOneContactModal &&
                <Modal>
                    <PreRegOneContact userMailMasked={maskedEmail} usePhoneMasked={maskedPhone}/>
                </Modal>
            }

            <div className={classes.preRegContainer}>                  
                {/* <div className={classes.preRegTitleContainer}>
                    <div role="heading" aria-level={1}>
                        <span className={classes.preRegTitle}>{Translate("N_General_SignUp_title_1")}</span>
                    </div>
                    <div className={classes.preRegTitleLinksWrapper} role="heading" aria-level={2}>
                        <span className={classes.preRegTitleLinkText}>{Translate('N_General_SignUp_lobby_info_3')}</span>
                        <a 
                            className={classes.preRegTitleLink1}
                            tabIndex={0} 
                            onClick={backToLoginPage}
                            onKeyPress={backToLoginPagePress}
                        >{Translate('N_General_Back_To_Login')}</a>
                        <span className={classes.preRegTitleLinkText}>{Translate('N_General_Or_Maybe')}</span>
                        <a 
                            className={classes.preRegTitleLink2}
                            tabIndex={0} 
                            onClick={forwardToForgotPassword}
                            onKeyPress={forwardToForgotPassPress}
                        >{Translate('N_General_Forgot_Password')}</a>
                    </div>
                </div>  */}
                <form className='normal-form'>                  
                    <div className={classes.formWrapper}>                                                
                        <div className={classes.preRegForm}>
                            <div className={classes.dynamicTextContainer}>
                                <DynamicText page="preReg"/>  
                            </div>                        
                            <div role="heading" aria-level={3}>
                                <div className={classes.preRegFormDesc}>{Translate('N_Login_Pre_Reg_Desc_1')}</div>
                                <div className={classes.preRegFormDesc}>{Translate('N_Login_Pre_Reg_Desc_2')}</div>
                            </div>
                            <div className={classes.preRegTimeDesc} role="heading" aria-level={4}>
                                {Translate('N_Login_Pre_Reg_Avg_Time')}
                            </div>
                            <div className={classes.preRegFieldsContainer}>
                                {/* user id */}
                                <div className={classes.preRegFieldWrapper}>
                                    <label className={classes.preRegLabel} htmlFor='userId'>
                                        <span>{Translate("N_General_SignUp_info_3")}</span>
                                        <span className={classes.preRegLabelDesc}>{Translate("N_General_SignUp_info_3_brackets")}</span>
                                    </label>
                                    <div>
                                        {/* <MaskedInput
                                            type='tel'
                                            id='userId'                                            
                                            aria-required="true"
                                            mask={[/\d/, /\d/, /\d/, /\d/,/\d/, /\d/, /\d/, /\d/, /\d/]}
                                            placeholder="_________"
                                            value={userId}
                                            onChange={handleUserId}
                                            onKeyPress={handleEnter}
                                            onBlur={handleIDBlur} 
                                            onFocus={handleIDFocus}   
                                            className={`form-control
                                            ${(!isUserIdValid && idDirty && idBlur) ? ' error-control' : '' }
                                            `}                                    
                                        /> */}

                                        <MaskInput
                                            type="tel"
                                            id="userId"
                                            autoComplete="off"
                                            ariaRequired={true}
                                            ariaInvalid={(!isIdValid() && idLengthValidation() && idDirty) ? true : false}
                                            ariaErrormessage="idError"
                                            mask="000000000"   // 9 digits
                                            placeholder="-"
                                            value={userId}
                                            onChange={(val) => 
                                                handleUserId({ 
                                                target: { value: val } 
                                                } as React.ChangeEvent<HTMLInputElement>)
                                            }
                                            onKeyPress={handleEnter}
                                            onBlur={handleIDBlur}
                                            onFocus={handleIDFocus}
                                            className={`form-control ${(!isIdValid() && idLengthValidation() && idDirty) ? 'error-control' : ''}`}
                                            />
                                    </div>
                                    {(!isUserIdValid && idDirty && idBlur) && (
                                        <div className='d-flex error'>
                                            <img
                                                src={alert}                            
                                                className={classes['error-alert']}
                                                alt=""
                                                aria-hidden="true"
                                            />
                                            &nbsp;
                                            <span className='small' id="idErr">
                                                {userId.length === 0
                                                ? Translate('N_General_Error_Mandatory_Field')
                                                : userId.length < 9
                                                ? Translate('N_General_Error_ID_NUMBER_TOO_SHORT')
                                                : Translate(
                                                    'N_General_Error_INVALID_ISRAELI_ID_NUM'
                                                    )}
                                            </span>
                                        </div>
                                    )}
                                </div>

                                {/* mail */}
                                <div className={classes.preRegFieldWrapper}>   
                                    <label className={classes.preRegLabel} htmlFor='mail'>
                                        <span>{Translate("N_Login_app_email_address")}</span>                                
                                    </label>
                                    <div className="input-group">
                                        <input 
                                            type='email'
                                            id='mail'
                                            ref={mailRef}
                                            aria-required="true"
                                            value={mail}
                                            onChange={handleMailValue}
                                            onKeyPress={handleEnter}
                                            className={
                                            !isMailValid && mailDirty
                                                ? 'form-control error-control'
                                                : 'form-control'
                                            }                            
                                        />                                
                                    </div>
                                    {!isMailValid && mailDirty && (
                                        <div className='d-flex error'>
                                            <img
                                                src={alert}                                    
                                                className={classes['error-alert']}
                                                alt=""
                                                aria-hidden="true"
                                            />
                                            &nbsp;
                                            <span className='small' id="mailErr">
                                            {mail.length === 0
                                                ? Translate('N_General_Error_Mandatory_Field')
                                                : Translate('N_General_Error_INVALID_EMAIL')}
                                            </span>
                                        </div>
                                    )}
                                </div>

                                {/* phone */}
                                <div className={classes.preRegFieldWrapper}>
                                    <label className={classes.preRegLabel} htmlFor='phoneNumber'>
                                        <span>{Translate("N_General_SignUp_info_8")}</span>                                
                                    </label>
                                    <div>
                                        <ReactInternationalPhone 
                                            id="phoneNumber" 
                                            getPhoneNumber={updatePhoneNumber}
                                            countryChange = {countryChangeHandler}
                                            reset = {false}  
                                            disabled = {false} 
                                            handleEnter={Submit} 
                                            pasteEnabled={true}
                                            ariaErrorMessage = "phoneVal"
                                            ariaDescribedBy = '' 
                                        />                                       
                                    </div>
                                    {!isPhoneValid && mobileDirty && (
                                        <div className='d-flex align-items-center'>
                                            <img
                                                src={alert}                                            
                                                className={classes['error-alert']}
                                                alt=""
                                                aria-hidden="true"
                                            />
                                            &nbsp;
                                            <span className='small error' id="phoneVal">
                                                {mobileValMsg}
                                            </span>
                                        </div>
                                    )}
                                </div>

                                {serverMessage.length > 0 && (
                                    <Toast message={serverMessage} />
                                )} 

                                <div>
                                    <button
                                        type='button'
                                        id="preRegBtn"
                                        className={classes.submit_btn}
                                        onClick={Submit}
                                        disabled={!isAllInputsValid()}
                                        >
                                            <span>{Translate("N_General_Start_Now")}</span>
                                            <img src= {arrowLeftWhite}  alt="" aria-hidden="true"/>
                                    </button>
                                </div>

                        </div>
                    </div>
                    <div className={classes.imgWrapper} aria-hidden="true">
                        <img src={arrowPanel} alt="arrow" id="imgTogglePanel" onClick={togglePanel} className={classes.imgPannel}/>
                    </div>
                </div> 
                </form>
            </div>
            <div ref={marketingRef}>
                <Marketing /> 
            </div>           
        </Fragment>
    );

};
export default PreRegistration;